<template>
<div class="content">
  <q-card>
    <div class="row">
      <div class="col-xs-12">
        <q-table
          :title="title"
          :data="workAssigned"
          :columns="columnsWorkAssigned"
          row-key="IdWorkAssign"
          :dense=true
          selection="single"
          :selected.sync="selectedRowsEvent"
          :loading="loading">

        <template slot="top-selection" slot-scope="props" >
          <div class="q-table-title">{{title}}</div>
          <div>
            <q-btn v-if="selectedRowsEvent[0].WorkCount == 0" color="secondary" flat :label="$t('global.Delete')" @click="deleteAssignment()" />
            <q-btn v-if="selectedRowsEvent[0].WorkCount != 0 && selectedRowsEvent[0].ClosedByUserId == null" color="secondary" flat :label="$t('global.CloseTask')" @click="closeAssignment" />
            <q-btn v-if="selectedRowsEvent[0].WorkCount != 0 && selectedRowsEvent[0].ClosedByUserId != null" color="secondary" flat :label="$t('global.ReopenTask')" @click="reopenAssignment" />
          </div>
        </template>
        <q-td slot="body-cell-Persons" slot-scope="props" :props="props">

          <q-btn-dropdown size="sm" :label="props.row.Persons[0].Name" v-if="props.row.Persons.length > 1">       
            <q-item v-for="p in props.row.Persons" :key="p.IdUser">
              {{p.Name}}
            </q-item>
          </q-btn-dropdown>
          <span v-if="props.row.Persons.length == 1">{{ props.row.Persons[0].Name }}</span>
          <span v-if="props.row.Persons.length == 0">Alle</span>
        </q-td>
        </q-table>
      </div>
    </div>
    </q-card>
</div>

</template>

<script>
import axios from 'axios'
import qs from 'qs'
import {eventBus} from '../../main'
import { date } from 'quasar'

export default {
  name: 'AssignWorkJournal',
  data: function () {
    return {
      loading: false,
      form: {
        SessionId: null,
        action: 'getOpenWork',
        IdLanguage: 1
      },
      workAssigned:[],
      selectedRowsEvent: [],  
      columnsWorkAssigned: [
      {
        name: 'Created', required: true, label: this.$t('global.Created'),align: 'left',
        field: 'Created',sortable: true,
        format: val => this.dateFormat(val)
      },
      {
        name: 'Resource', required: true, label: this.$t('global.Work'), align: 'left',
        field: 'Resource',sortable: true
      },
      {
        name: 'GeoRegion', required: true,label: this.$t('global.Field'),align: 'left',
        field: 'GeoRegion',sortable: true
      },
      {
        name: 'Product', required: true,label: this.$t('global.Product'),align: 'left',
        field: 'Product',sortable: true
      },
      {
        name: 'Comment', required: true,label: this.$t('global.Comment'),align: 'left',
        field: 'Comment',sortable: true
      },
      {
        name: 'Persons', required: true,label: this.$t('global.People'),align: 'left',
        field: 'Persons',sortable: true
      }
      ],
      columnHeaders: ['global.Created','global.Work','global.Field','global.Comment','global.People'],
    }
  },
  methods: {
    loadWorkAssigned(){
      this.form.SessionId = this.$store.state.session.SessionId
      this.form.action = "getWorkAssign"
      this.form.type = this.type
      axios.post(this.$apiUrl,
      qs.stringify(this.form),
      {
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
      })
      .then(response => {
          this.submitting = false
          if(response.status == 200){ 
              this.workAssigned = response.data
          }
          else{
              this.$q.notify('Something Wrong.')
          }
      })
      .catch(e => {
        this.$q.notify('Something Wrong.')
        console.log(e);
      })
    },
    deleteAssignment(){
      var self = this
      this.$q.dialog({
        title: this.$t('global.DeleteEntry'),
        message: this.$t('global.DeleteEntryQuestion'),
        color: 'primary',
        ok: true, // takes i18n value, or String for "OK" button label
        cancel: true, // takes i18n value, or String for "Cancel" button label
        preventClose: true,
        noBackdropDismiss: false, // gets set to "true" automatically if preventClose is "true"
        noEscDismiss: false, // gets set to "true" automatically if preventClose is "true"
        stackButtons: false,
        position: 'top',        
      })
      .then(() => {
        var IdWorkAssign = this.selectedRowsEvent[0].IdWorkAssign
        this.form.SessionId = this.$store.state.session.SessionId
        this.form.action = "deleteWorkAssign"
        this.form.IdWorkAssign = IdWorkAssign
        axios.post(this.$apiUrl,
        qs.stringify(this.form),
        {
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
        })
        .then(response => {
            this.submitting = false
            if(response.status == 200){ 
              this.$q.notify({ message: this.$t('global.EntryDeleted'), type: 'positive' })
              this.loadWorkAssigned()
              this.selectedRowsEvent = []
              eventBus.$emit('WorkAssignUpdate', null)
            }
            else{
                this.$q.notify('Something Wrong.')
            }
        })
        .catch(e => {
          this.$q.notify('Something Wrong.')
          console.log(e);
        })
      })
      .catch(() => {
        //alert('Picked cancel')
      })
    },
    closeAssignment (){
      this.$q.dialog({
        title: this.$t('global.CloseTask'),
        message: this.$t('global.CloseTaskQuestion'),
        color: 'primary',
        ok: true, // takes i18n value, or String for "OK" button label
        cancel: true, // takes i18n value, or String for "Cancel" button label
        preventClose: true,
        noBackdropDismiss: false, // gets set to "true" automatically if preventClose is "true"
        noEscDismiss: false, // gets set to "true" automatically if preventClose is "true"
        stackButtons: false,
        position: 'top',        
      })
      .then(() => {
        var IdWorkAssign = this.selectedRowsEvent[0].IdWorkAssign
        this.form.SessionId = this.$store.state.session.SessionId
        this.form.action = "closeWorkAssign"
        this.form.IdWorkAssign = IdWorkAssign
        axios.post(this.$apiUrl,
        qs.stringify(this.form),
        {
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
        })
        .then(response => {
            this.submitting = false
            if(response.status == 200){ 
              this.$q.notify({ message: this.$t('global.EntryDeleted'), type: 'positive' })
              this.loadWorkAssigned()
              this.selectedRowsEvent = []
              eventBus.$emit('WorkAssignUpdate', null)
            }
            else{
                this.$q.notify('Something Wrong.')
            }
        })
        .catch(e => {
          this.$q.notify('Something Wrong.')
          console.log(e);
        })
      })
      .catch(() => {
        //alert('Picked cancel')
      })
    },
    reopenAssignment (){
      this.$q.dialog({
        title: this.$t('global.ReopenTask'),
        message: this.$t('global.ReopenTaskQuestion'),
        color: 'primary',
        ok: true, // takes i18n value, or String for "OK" button label
        cancel: true, // takes i18n value, or String for "Cancel" button label
        preventClose: true,
        noBackdropDismiss: false, // gets set to "true" automatically if preventClose is "true"
        noEscDismiss: false, // gets set to "true" automatically if preventClose is "true"
        stackButtons: false,
        position: 'top',        
      })
      .then(() => {
        var IdWorkAssign = this.selectedRowsEvent[0].IdWorkAssign
        this.form.SessionId = this.$store.state.session.SessionId
        this.form.action = "reopenWorkAssign"
        this.form.IdWorkAssign = IdWorkAssign
        axios.post(this.$apiUrl,
        qs.stringify(this.form),
        {
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
        })
        .then(response => {
            this.submitting = false
            if(response.status == 200){ 
              this.$q.notify({ message: this.$t('global.EntryDeleted'), type: 'positive' })
              this.loadWorkAssigned()
              this.selectedRowsEvent = []
              eventBus.$emit('WorkAssignUpdate', null)
            }
            else{
                this.$q.notify('Something Wrong.')
            }
        })
        .catch(e => {
          this.$q.notify('Something Wrong.')
          console.log(e);
        })
      })
      .catch(() => {
        //alert('Picked cancel')
      })
    },
    dateFormat(val) {
      //return date.formatDate(val, 'DD.MM.YYYY HH:mm')
      //return new Date(val).toLocaleString('de-DE')
      return date.formatDate(val, this.$store.state.session.DateTimeFormat)
    },

  },
  props: ['type'],
  created () {
    this.loadWorkAssigned()
    eventBus.$on('WorkAssignUpdate', (data) => {
      this.loadWorkAssigned()
    }),
    eventBus.$on('Bus_ChangeLocale', (data) => {
      var cnr = 0
      this.columnHeaders.forEach(col => {
      this.columnsWorkAssigned[cnr].label = this.$t(col)
      cnr++
      })
    })
  },
  computed: {
    title: function () {
      if(this.type == 'open')
        return this.$t('global.CurrentOrders')
      if(this.type == 'last')
        return this.$t('global.LastOrders')
    }

  },
}
</script>
<style scoped>
.content{
  padding: 10px;
}
.titel{
  text-align: center;
}
</style>